module.exports = __webpack_public_path__ + "b4579dff5737e612e46b85b75fc17cec.fbx";